export default {"src":"/_next/static/media/regen-design-build-logo.bb1c0076.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};